import * as React from "react";
import { match } from "react-router-dom";
import Create from "./Ops.ApplicationStatusMessages.Create";

type Props = {
  match: match<{ id: string }>;
  category: string;
  level: string;
  messageBody: string;
  id: string;
};

class Edit extends React.Component<Props> {
  render() {
    const { state } = this.props.location;
    return (
      <Create
        editMode={true}
        category={state.category}
        level={state.level}
        messageBody={state.messageBody}
        id={state.id}
      />
    );
  }
}

export default Edit;
